import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaBowlRice, FaMugHot } from 'react-icons/fa6'; 
import { GiHotMeal } from 'react-icons/gi';
import { BsCheckCircleFill } from 'react-icons/bs';

const AvailableCombos = () => {
  // TJP Brand Colors
  const colors = {
    primaryOrange: '#FD7E4B',
    primaryGreen: '#2e7d32',
    creamBg: '#FDF0DD',
    lightGreen: '#e8f5e9',
    lightOrange: '#fff3e0'
  };

  // Animation settings
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    hover: { scale: 1.02, boxShadow: "0px 5px 15px rgba(0,0,0,0.1)" }
  };

  return (
    <section style={{ backgroundColor: colors.creamBg }} className="py-5" id="combos">
      <Container>
        {/* Compact Header */}
        <div className="text-center mb-4" data-aos="fade-up">
          <h6 className="text-uppercase fw-bold small" style={{ color: colors.primaryOrange, letterSpacing: '1px' }}>
            Morning Fuel
          </h6>
          <h3 className="fw-bold text-dark">
            Curated Breakfast Combos
          </h3>
        </div>

        <Row className="g-3 justify-content-center">
          
          {/* --- 2-Item Combo Card (Compact) --- */}
          <Col md={6} lg={5}>
            <motion.div
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true }}
            >
              <Card className="h-100 border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                <div className="p-3 text-center">
                  {/* Title Section */}
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                    <div className="p-2 rounded-circle" style={{ backgroundColor: colors.lightGreen, color: colors.primaryGreen }}>
                      <GiHotMeal size={20} />
                    </div>
                    <h5 className="fw-bold mb-0">2-Item Combo</h5>
                    <Badge className="rounded-pill" style={{fontSize: '0.65rem', backgroundColor: colors.primaryGreen}}>Popular</Badge>
                  </div>
                  
                  <p className="text-muted small mb-3">Light & balanced start to the day.</p>
                  
                  {/* Horizontal Equation (Space Saver) */}
                  <div className="d-flex align-items-center justify-content-center bg-light rounded p-2 mb-3 gap-2 flex-wrap" style={{ fontSize: '0.9rem' }}>
                    <div className="d-flex align-items-center">
                        <FaBowlRice className="text-secondary me-1" size={14}/> 
                        <span className="fw-semibold">Regular</span>
                    </div>
                    <span className="text-muted small">+</span>
                    <div className="d-flex align-items-center">
                        <FaMugHot className="text-warning me-1" size={14}/> 
                        <span className="fw-semibold">Porridge/Soup</span>
                    </div>
                  </div>

                  {/* Checklist */}
                  <div className="d-flex justify-content-center gap-3 mb-3">
                    <small className="d-flex align-items-center text-muted"><BsCheckCircleFill className="text-success me-1" size={12}/> Light</small>
                    <small className="d-flex align-items-center text-muted"><BsCheckCircleFill className="text-success me-1" size={12}/> Balanced</small>
                  </div>

                  <Button variant="outline-success" size="sm" className="w-100 rounded-3 fw-bold">
                    Select 2-Item
                  </Button>
                </div>
              </Card>
            </motion.div>
          </Col>

          {/* --- 3-Item Combo Card (Compact) --- */}
          <Col md={6} lg={5}>
             <motion.div
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true }}
            >
              <Card className="h-100 border-0 shadow-sm" style={{ borderRadius: '15px', borderTop: '4px solid #e67e22' }}>
                <div className="p-3 text-center">
                  {/* Title Section */}
                   <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                    <div className="p-2 rounded-circle" style={{ backgroundColor: colors.lightOrange, color: colors.primaryOrange }}>
                      <FaBowlRice size={20} />
                    </div>
                    <h5 className="fw-bold mb-0">3-Item Combo</h5>
                    <Badge className="rounded-pill" style={{fontSize: '0.65rem', backgroundColor: colors.primaryOrange, color: '#fff'}}>Full Meal</Badge>
                  </div>
                  
                  <p className="text-muted small mb-3">Wholesome & complete nutrition.</p>

                  {/* Horizontal Equation (Space Saver) */}
                  <div className="d-flex align-items-center justify-content-center bg-light rounded p-2 mb-3 gap-2 flex-wrap" style={{ fontSize: '0.9rem' }}>
                    <div className="d-flex align-items-center">
                        <FaBowlRice className="text-secondary me-1" size={14}/> 
                        <span className="fw-semibold">Regular</span>
                    </div>
                    <span className="text-muted small">+</span>
                    <div className="d-flex align-items-center">
                        <FaMugHot className="text-warning me-1" size={14}/> 
                        <span className="fw-semibold">Porridge</span>
                    </div>
                    <span className="text-muted small">+</span>
                    <div className="d-flex align-items-center">
                        <FaMugHot className="text-success me-1" size={14}/> 
                        <span className="fw-semibold">Soup</span>
                    </div>
                  </div>

                  {/* Checklist */}
                  <div className="d-flex justify-content-center gap-3 mb-3">
                    <small className="d-flex align-items-center text-muted"><BsCheckCircleFill className="text-success me-1" size={12}/> Filling</small>
                    <small className="d-flex align-items-center text-muted"><BsCheckCircleFill className="text-success me-1" size={12}/> High Fiber</small>
                  </div>

                  <Button variant="success" size="sm" className="w-100 rounded-3 fw-bold" style={{ backgroundColor: colors.primaryOrange, borderColor: colors.primaryOrange, color: '#fff' }}>
                    Select 3-Item
                  </Button>
                </div>
              </Card>
            </motion.div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default AvailableCombos;